"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackLink = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var hooks_1 = require("../../hooks");
var BackLink = function (_a) {
    var className = _a.className, pageLabel = _a.pageLabel, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, props = __rest(_a, ["className", "pageLabel", "onClick", "onFocus", "onBlur"]);
    var itemRef = react_1.default.useRef(null);
    var _b = hooks_1.useFocusVisible(itemRef, onBlur, onFocus), isFocusVisible = _b.isFocusVisible, focusFunction = _b.focusFunction, blurFunction = _b.blurFunction;
    var BackLinkClasses = classnames_1.default('BackLink', className, {
        'BackLink--focus-visible': isFocusVisible,
    });
    // Need to break out label into sections to make good Sketch Symbols
    var backLink = pageLabel ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "BackLink__label" }, "Back to\u00A0"),
        react_1.default.createElement("span", { className: "BackLink__page-label" }, pageLabel))) : (react_1.default.createElement("span", { className: "BackLink__label" }, "Back"));
    var LinkElement = props.href ? 'a' : 'div';
    return (react_1.default.createElement(LinkElement, __assign({ className: BackLinkClasses, onClick: onClick, onFocus: focusFunction, onBlur: blurFunction, ref: itemRef, tabIndex: 0 }, props),
        react_1.default.createElement(__1.Icon, { className: "BackLink__back-icon", name: "chevron_left" }),
        backLink));
};
exports.BackLink = BackLink;
//# sourceMappingURL=BackLink.js.map